import { render, staticRenderFns } from "./CloudCma.vue?vue&type=template&id=59967560"
import script from "./CloudCma.vue?vue&type=script&lang=js"
export * from "./CloudCma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports